<template>
  <section class="foot-page">
    <div>
      <ul>
        <li><a target="_blank" href="//17zuoye.com/help/aboutus.vpage">关于我们</a></li>
        <li><a target="_blank" href="//17zuoye.com/help/news/index.vpage">新闻中心</a></li>
        <!-- <li><a href="javascript:void(0)">用户声音</a></li> -->
        <li><a target="_blank" href="//17zuoye.com/help/jobs.vpage">诚聘英才</a></li>
        <!-- <li><a href="javascript:void(0)">帮助中心</a></li> -->
        <li>
          <a target="_blank" href="//17zuoye.com/project/educationsubject/list.vpage">课题相关</a>
        </li>
        <!-- <li><a href="javascript:void(0)">用户协议</a></li> -->
        <li>
          <a target="_blank" href="//17zuoye.com/help/privacyprotection.vpage">隐私保护</a>
        </li>
        <!-- <li><a href="javascript:void(0)">新浪微博</a></li> -->
      </ul>
    </div>
    <div class="f-item2">
      <span
        >Copyright © 2011-2018 Yiqizuoye Corporation. All Rights Reserved. ICP证沪B2-20150026
        沪ICP备13031855号-2 <img src="@/assets/svg/Bitmap.png" alt="" />京公网安备
        11010502032354号</span
      >
    </div>
  </section>
</template>

<script>
export default {
  name: 'Footer',
  props: {
    msg: String
  }
}
</script>
<style scoped lang="scss">
.foot-page {
  a {
    color: rgba(0, 0, 0, 0.65);
  }
  text-align: center;
  ul li {
    display: inline-block;
    list-style: none;
    margin-right: 24px;
    width: 48px;
    height: 20px;
    font-size: 12px;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.65);
    line-height: 20px;
  }
  .f-item2 {
    // width: 841px;
    margin-top: -10px;
    height: 20px;
    font-size: 12px;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.45);
    line-height: 20px;
  }
}
</style>
